import TeamsList from './TeamsList';

export default TeamsList;
